const BI_EVENTS = {
  PARTNER_CHECKOUT_OPEN: 'checkout_open',
  PARTNER_CHECKOUT_CLOSE: 'checkout_close',
};

const createBiEvent =
  (event: typeof BI_EVENTS[keyof typeof BI_EVENTS]) => () => {
    const biUrl = `${window.location.origin}/report/bi/${event}`;
    fetch(biUrl, {method: 'POST'});
  };

export const useBiEvents = () => {
  return {
    sendPartnerCheckoutOpen: createBiEvent(BI_EVENTS.PARTNER_CHECKOUT_OPEN),

    sendPartnerCheckoutClose: createBiEvent(BI_EVENTS.PARTNER_CHECKOUT_CLOSE),
  };
};
